var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwardIconColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1393_44684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9811 17.4701C15.8054 17.4701 19.7162 13.5593 19.7162 8.73504C19.7162 3.91081 15.8054 0 10.9811 0C6.1569 0 2.24609 3.91081 2.24609 8.73504C2.24609 13.5593 6.1569 17.4701 10.9811 17.4701Z",
    fill: "#F8B64C",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90395 13.8453L0.898438 19.0552L4.40631 18.8689L6.00001 22L8.78033 17.18C6.7882 16.6646 5.07757 15.465 3.90395 13.8453ZM18.074 13.8193C16.9091 15.4434 15.1984 16.6473 13.2106 17.1713L15.9996 22L17.5933 18.8689L21.1012 19.0552L18.074 13.8193Z",
    fill: "#406B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9799 15.0663C14.4767 15.0663 17.3114 12.2316 17.3114 8.73482C17.3114 5.23803 14.4767 2.40332 10.9799 2.40332C7.48315 2.40332 4.64844 5.23803 4.64844 8.73482C4.64844 12.2316 7.48315 15.0663 10.9799 15.0663Z",
    fill: "#F8B64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3191 8.05095C15.514 7.8604 15.4057 7.52693 15.1372 7.48795L12.6384 7.12418C12.5301 7.10685 12.4392 7.04189 12.3915 6.94229L11.2742 4.67733C11.153 4.43047 10.8022 4.43047 10.6809 4.67733L9.56792 6.94229C9.52028 7.03756 9.42501 7.10685 9.32107 7.12418L6.82225 7.48795C6.55375 7.52693 6.44548 7.8604 6.64036 8.05095L8.44627 9.81355C8.52422 9.8915 8.55887 9.99977 8.54154 10.1037L8.11713 12.5895C8.0695 12.858 8.35532 13.0659 8.59784 12.936L10.8325 11.7624C10.9278 11.7104 11.0447 11.7104 11.14 11.7624L13.3746 12.936C13.6171 13.0616 13.8986 12.858 13.8553 12.5895L13.4266 10.1037C13.4093 9.99544 13.4439 9.88717 13.5219 9.81355L15.3191 8.05095Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1393_44684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardIconColor);
export default __webpack_public_path__ + "static/media/AwardIconColor.f907fb35b708da0f537b08d807a2f58f.svg";
export { ForwardRef as ReactComponent };